import { render, staticRenderFns } from "./PowerHistoryItem.vue?vue&type=template&id=fb764df2&scoped=true"
import script from "./PowerHistoryItem.vue?vue&type=script&lang=js"
export * from "./PowerHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./PowerHistoryItem.vue?vue&type=style&index=0&id=fb764df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb764df2",
  null
  
)

export default component.exports